<template>
    <div>
        <div v-if="course">
            <ssv-order-error-state
                    message="Omlouváme se, ale kapacita kurzu je již naplněna"
                    v-if="courseDate && false === courseDate.isVacant"
            />
            <ssv-order-container v-if="(!courseDate && course) || (courseDate && courseDate.isVacant)"/>
        </div>
        <ssv-order-error-state message="Objednávku se nepodařilo načíst" v-if="error"/>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import {getCourseDate, getCourseBySlug} from './api/course';
    import SsvOrderContainer from './order/OrderContainer';
    import SsvOrderErrorState from "./error/ErrorState";

    export default {
        name: 'SsvOrderWrap',
        components: {
            SsvOrderErrorState,
            SsvOrderContainer
        },
        data() {
            return {
                processing: true,
                error: false,
            }
        },
        computed: {
            ...mapGetters('ssvOrder', ['courseDate', 'course', 'gift'])
        },
        mounted() {
            const isGift = this.$route.fullPath.indexOf('darkovy-poukaz') !== -1;
            const {courseDateId, courseSlug} = this.$route.params;
            if (isGift) {
                this.setGift(isGift);
                getCourseBySlug(courseSlug)
                    .then((response) => {
                        this.setCourse(response);
                        if (isGift && !response.canBeGifted) {
                            window.location.href = '/skola-suche-vystavby/';
                            return;
                        }
                    })
                    .catch(() => this.error = true)
                    .finally(() => this.processing = false);
            } else {
                getCourseDate(courseDateId)
                    .then((response) => {
                        const {course, trainingCenter} = response;
                        delete response.course;
                        delete response.trainingCenter;
                        this.setCourse(course);
                        this.setTrainingCenter(trainingCenter);
                        this.setCourseDate(response);
                    })
                    .catch(() => this.error = true)
                    .finally(() => this.processing = false);
            }
        },
        methods: {
            ...mapActions('ssvOrder', ['setCourse', 'setCourseDate', 'setTrainingCenter', 'setGift'])
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/OrderWrap.vue